import { ITableBooking } from '@entities/booking/types';
import { CalendarEvent } from '@types';

export const transformTableDataToEvents = (
    data: ITableBooking[]
): CalendarEvent[] => {
    const events: CalendarEvent[] = [];

    data.forEach(table => {
        if (table.bookings && table.bookings.length > 0) {
            table.bookings.forEach(booking => {
                const startDate = new Date(booking.bookingStart);
                const dateStr = startDate.toISOString().split('T')[0];

                const content = `Стол ${table.number}: ${booking.personName}`;

                events.push({
                    type: 'success',
                    content,
                    bookingData: {
                        ...booking,
                        tableName: table.name,
                        hallName: table.hall.name,
                        price: table.price,
                        state: table.state,
                    },
                    date: dateStr,
                });
            });
        }
    });

    return events;
};
